import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-panel-main',
  templateUrl: './panel-main.component.html',
  styleUrls: ['./panel-main.component.css']
})
export class PanelMainComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
